import { render, staticRenderFns } from "./InquiriesCheckPopup.vue?vue&type=template&id=bdb6c0e4&scoped=true&"
import script from "./InquiriesCheckPopup.vue?vue&type=script&lang=js&"
export * from "./InquiriesCheckPopup.vue?vue&type=script&lang=js&"
import style0 from "./InquiriesCheckPopup.vue?vue&type=style&index=0&id=bdb6c0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb6c0e4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/InquiriesCheckPopup.vue
// module id = null
// module chunks = 